import script from "./DashboardV3.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardV3.vue?vue&type=script&setup=true&lang=js"

import "./DashboardV3.vue?vue&type=style&index=0&id=4645d6fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4645d6fc"]])

export default __exports__